const getters = {
  userInfo: state => state.user.userInfo,
  userId: state => {
    const info = state.user.userInfo
    if (!info) return 0
    const idLike = info.id ?? info.uid ?? 0
    const parsed = parseInt(idLike, 10)
    return Number.isNaN(parsed) ? 0 : parsed
  },
  oss: state => state.user.oss,
  permissions: state => state.user.permissions,
  permissionsObj: state => state.user.permissionsObj,
  routes: state => state.user.routes,
  routeTag: state => state.tag.routeTag
}
export default getters
